export default function ModeDemandeModal({ onChoisir, onCancel, requerant }) {
  const nomComplet = requerant
    ? [requerant.prenom, requerant.nom].filter(Boolean).join(" ").trim()
    : "";
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000050 }}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 480, maxWidth: "94vw" }}
           data-testid="mode-demande-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15,
                      display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>NOUVELLE DEMANDE</span>
          <button className="win-modal-close" onClick={onCancel} data-testid="mode-demande-btn-x">×</button>
        </div>
        <div style={{ padding: 24, fontSize: 15 }}>
          {(nomComplet || requerant?.date_naissance) && (
            <div data-testid="mode-demande-requerant"
                 style={{ background: "#eaf2fb", border: "1px solid #c4d8f0", borderLeft: "4px solid #1e5aa8",
                          borderRadius: 4, padding: "10px 14px", marginBottom: 18, fontSize: 14 }}>
              <div style={{ color: "#555", fontSize: 12, marginBottom: 2 }}>Création d'un dossier pour :</div>
              <div style={{ fontWeight: 700, color: "#164a8f" }} data-testid="mode-demande-requerant-nom">
                {nomComplet || "—"}
              </div>
              {requerant?.date_naissance && (
                <div style={{ color: "#333", fontSize: 13 }} data-testid="mode-demande-requerant-ddn">
                  Né(e) le : {requerant.date_naissance}
                </div>
              )}
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <button onClick={() => onChoisir("reguliere")}
                    style={{ padding: "12px 0", fontSize: 15, fontWeight: 700,
                             background: "#1e5aa8", color: "#fff", border: "1px solid #164a8f",
                             cursor: "pointer" }}
                    data-testid="mode-demande-reguliere">
              Abrégé
            </button>
            <button onClick={() => onChoisir("conditionnelle")}
                    style={{ padding: "12px 0", fontSize: 15, fontWeight: 700,
                             background: "#1e5aa8", color: "#fff", border: "1px solid #164a8f",
                             cursor: "pointer" }}
                    data-testid="mode-demande-conditionnelle">
              Conditionnelle
            </button>
            <button onClick={() => onChoisir("entrevue")}
                    style={{ padding: "12px 0", fontSize: 15, fontWeight: 700,
                             background: "#1e5aa8", color: "#fff", border: "1px solid #164a8f",
                             cursor: "pointer" }}
                    data-testid="mode-demande-entrevue">
              Complète
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
